import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminProvider } from "@/context/AdminContext";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Header from "@/components/Header";
import { trackEvent } from "@/lib/api";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import CodCheckout from "@/pages/CodCheckout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import MyOrders from "@/pages/MyOrders";
import AdminLogin from "@/pages/AdminLogin";
import AdminProducts from "@/pages/AdminProducts";
import AdminOrders from "@/pages/AdminOrders";
import AdminSettings from "@/pages/AdminSettings";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminCustomers from "@/pages/AdminCustomers";
import Footer from "@/components/Footer";

const Layout = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/admin")) trackEvent("page_view", { path: pathname });
  }, [pathname]);
  // Handle the Emergent Google OAuth redirect synchronously during render
  // (before any route/auth checks) to avoid race conditions.
  if (hash?.includes("session_id=")) return <AuthCallback />;
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <div className="bg-[#7f1515] text-white/90 text-[11px] tracking-[0.18em] uppercase text-center py-1" data-testid="powered-by-strip">
        powered by <span className="font-bold text-[#ffe500]">VIGNESH</span>
      </div>
      {!isAdmin && <Header />}
      <div className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<CategoryPage />} />
          <Route path="/category/:name" element={<CategoryPage />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/cod-checkout" element={<CodCheckout />} />
          <Route path="/order/:id" element={<OrderConfirmation />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
        </Routes>
      </div>
      {!isAdmin && <Footer />}
      <Toaster position="bottom-center" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AdminProvider>
          <CartProvider>
            <BrowserRouter>
              <Layout />
            </BrowserRouter>
          </CartProvider>
        </AdminProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
